












import { Component, Mixins } from "vue-property-decorator";
import { MultiOrderableSelectableMixin } from "../../system/selectors/mixins";
import MultiOrderableOptionListBoxSelector from "../../system/selectors/MultiOrderableOptionListBoxSelector.vue";
import { ProfessionsSelectableMixin } from "./mixins";

@Component({
  components: {
    MultiOrderableOptionListBoxSelector,
  },
})
export default class MultiOrderableProfessionListSelector extends Mixins(ProfessionsSelectableMixin, MultiOrderableSelectableMixin) {
}
